<template>
  <div class="home">
    <div class="tip py-2">
      <div class="lh-1-6">
        <span class="bold">投票时间：</span>2021年8月12日——8月18日
      </div>
      <div class="lh-1-6">
        <span class="bold">投票规则：</span>每个微信只能投票1次，投票时至少需选够5本书，勾选的书单需覆盖5个类别，才能投票。投票完成后，将获得特惠购书优惠券。
      </div>
    </div>
    <div class="mt-5">
      <ul class="tab">
        <li
          class="item"
          :class="{'act':tab==index}"
          v-for="(item, index) in category"
          :key="item.id"
          @click="tabClick(index, item.id)"
        >
          {{item.name}}<span v-if="!isVote && is_vote_stop == 0">(已选{{numList[item.id]}})</span>
        </li>
      </ul>
    </div>
    <div class="mt-5">
      <div class="book">
        <van-list
          v-model="bookLoading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load='onload'
          ref="list"
        >
          <ul class="list">
            <li
              v-for="(item,index) in list"
              :key="index"
            >
              <div class="img-box">

                <img
                  v-if="item.image"
                  :src="'https://huodong.zsnews.cn'+item.image"
                  alt=""
                >
                <img
                  v-else
                  src="@/assets/images/book.png"
                  alt=""
                >
              </div>
              <div class="desc p-3">
                <div class="name bold">{{item.name}}</div>
                <div class="rank mt-1">实时排名：{{item.rank}}</div>
                <div
                  class="mt-1"
                  v-if="item.recommend_name"
                >荐书人：{{item.recommend_name}}</div>
                <div class="mt-1">
                  <van-checkbox
                    v-if="!isVote && is_vote_stop == 0"
                    v-model="item.checked"
                    shape="square"
                    checked-color="#eb6100"
                    @click="bookClick(item)"
                  ></van-checkbox>
                  <div class="num">{{item.vote_num}}票</div>
                </div>
              </div>
            </li>
          </ul>

        </van-list>
        <div
          v-if="!isVote && is_vote_stop == 0"
          class="vote-group fixed"
        >
          <van-button
            block
            type="info"
            class="confirm-btn"
            :disabled="loading"
            loading-text="投票"
            @click="voteClick"
          >投票</van-button>
          <div class="mt-1 t-center">已选票数<span class="color-orange bold">{{sum}}/5</span>，已选分类<span class="color-orange bold">{{ids.length}}/5</span></div>
        </div>
      </div>
    </div>
    <user-info-form :formshow="userFormShow" />
  </div>
</template>

<script>
import '@/assets/css/home.css'
import UserInfoForm from '@/components/UserInfoForm.vue'
import { Checkbox, Button, Loading, List } from 'vant'
import { userStatus, getBookList, voteBookSave, bookCategory, isAuth } from '@/api'
export default {
  name: 'Home',
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [List.name]: List,
    [Loading.name]: Loading,
    UserInfoForm
  },
  data() {
    return {
      id: 1,
      page: 0,
      size: 16,
      userFormShow: 0,
      tab: 0,
      isVote: 0,
      is_vote_stop: 0,
      loading: false,
      selectNum: 0, //已选票数
      selectType: 0,//已选类别
      sum: 0,
      numList: {},
      ids: [],
      category: [],//书单分类
      list: [],
      bookLoading: false,
      finished: false,
      error: false
    }
  },
  created() {
    isAuth().then((res) => {
      if (res.data.isAuth) {
        // 已授权
        this.getBookCategory()
        // 获取是否已投票
        this.userStatus()
      } else {
        //未授权
        const url = window.location.href
        window.location.href = "https://huodong.zsnews.cn/purchasebooks/auth?redirect_url=" + url
      }
    })
  },
  methods: {
    userStatus() {
      userStatus().then((res) => {
        this.isVote = res.data.is_vote
        this.is_vote_stop = res.data.is_vote_stop
      })
    },
    tabClick(index, id) {
      this.finishNum = 0
      this.finished = false
      this.page = 0
      this.tab = index
      this.id = id
      this.list = []
      // this.getBookList()
    },
    onload() {
      this.page++
      this.getBookList()
    },
    // 获取书单分类
    getBookCategory() {
      bookCategory().then((res) => {
        this.category = res.data.list
        this.category.forEach((item) => {
          // 设置每个类别的数量
          this.numList[item.id] = 0
        })
      })
    },
    getBookList() {
      const data = {
        id: this.id,
        page: this.page,
        size: this.size
      }
      getBookList(data).then((res) => {
        this.bookLoading = false
        if (res.msg == '数据加载完成') {
          this.finished = true
          this.finishNum++
          return false
        }
        this.list = this.list.concat(res.data.list)
        // 设置对应书本的checked属性
        let book_ids = []
        this.ids.forEach((item) => {
          if (item.id == this.id) {
            book_ids = item.book_ids
          }
        })
        this.list.forEach((item) => {
          book_ids.forEach((id) => {
            if (id == item.id) {
              item.checked = true
            }
          })
        })
      }).catch(() => {
        this.bookLoading = false
        this.error = true
      })
    },
    // 更新
    updateBookList() {
      const data = {
        id: this.id,
        page: this.page,
        size: this.size
      }
      getBookList(data).then((res) => {
        console.log(res)
        this.bookLoading = false
        if (res.msg == '数据加载完成') {
          this.finished = true
          this.finishNum++
          return false
        }
        this.list = res.data.list
        // 设置对应书本的checked属性
        let book_ids = []
        this.ids.forEach((item) => {
          if (item.id == this.id) {
            book_ids = item.book_ids
          }
        })
        this.list.forEach((item) => {
          book_ids.forEach((id) => {
            if (id == item.id) {
              item.checked = true
            }
          })
        })
      }).catch(() => {
        this.bookLoading = false
        this.error = true
      })
    },
    voteClick() {
      if (this.ids.length < 5) {
        this.$toast("每个分类至少选择一本书")
        return false
      }
      this.$toast.loading({
        message: '提交中',
        duration: 0
      })
      this.loading = true
      voteBookSave(this.ids).then(() => {
        this.$toast.clear()
        this.userStatus()
        this.updateBookList()
        this.userFormShow++
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    bookClick(item) {
      const pid = this.id
      let ishave = false
      if (item.checked) {
        this.sum++
        this.numList[pid]++
        this.$forceUpdate()

        this.ids.forEach((value) => {
          // 判断是否存在类别
          if (value.id == pid) {
            value.book_ids.push(item.id)
            ishave = true
          }
        })
        if (!ishave) {
          let id = {
            id: pid,
            book_ids: []
          }
          id.book_ids.push(item.id)
          this.ids.push(id)
        }

      } else {
        // 取消选择
        this.sum--
        this.numList[pid]--
        this.$forceUpdate()
        this.ids.forEach((value1, index1) => {
          if (value1.id == pid) {
            value1.book_ids.forEach((value2, index2) => {
              if (value2 == item.id) {
                value1.book_ids.splice(index2, 1)
              }
              if (value1.book_ids.length == 0) {
                this.ids.splice(index1, 1)
              }
            })
          }
        })
      }
    }
  }
}
</script>
